import colors from 'assets/styles/jsVariables/colors';

export default {
  headerContainer: {
    backgroundColor: colors.purple,
    height: 199
  },
  header: {
    width: '100%',
    height: '100%',
    paddingTop: 36
  },
  drawer: {
    top: 64,
    bottom: 0,
    left: 0,
    zIndex: 98,
    height: 'initial',
    overflow: 'auto',
    position: 'absolute',
    paddingBottom: '64px'
  },
  drawerOverlay: {
    opacity: 0,
    zIndex: 97
  },
  flatButton: {
    position: 'absolute',
    top: 15,
    left: -10
  },
  cross: {
    height: 18,
    width: 18
  },
  avatarContainer: {
    textAlign: 'center'
  },
  name: {
    fontFamily: 'proxima_novaregular',
    color: colors.lightestGrey,
    fontSize: 19,
    textAlign: 'center',
    marginBottom: 0,
  },
  teamName: {
    fontFamily: 'proxima_novaregular',
    color: colors.lightestGrey,
    fontSize: 12,
    textAlign: 'center',
    opacity: 0.7,
    marginTop: -12
  },
  listItem: {
    paddingLeft: 36,
    paddingTop: 10,
    paddingBottom: 10,
    fontFamily: 'proxima_novaregular',
    fontSize: 18,
    lineHeight: '20px',
    color: '#a8a8a8'
  },
  listInnerDiv: {
    padding: 0
  },
  listSubheaderLabel: {
    fontFamily: 'proxima_novaregular',
    fontSize: '18px',
    lineHeight: '22px',
    letterSpacing: 0,
    fontWeight: 500,
    color: '#4d4d4e'
  },
  listSubheaderInnerDiv: {
    marginTop: 0,
    minWidth: 0
  },
  listSubheaderDivider: {
    marginBottom: 10,
    background: colors.lightGrey
  },
  listSubheader: {
    marginTop: 30,
    marginLeft: 36,
    marginRight: 36
  },
  selectedListItem: {
    color: '#4a4a4a',
    fontFamily: 'proxima_novasemibold'
  },
  divider: {
    backgroundColor: colors.lightestGrey,
    marginTop: 10,
    marginBottom: 10
  },
  navIcon: {
    width: 20,
    heigth: 20
  },
  secondaryNavIcon: {
    width: 18,
    heigth: 18
  }
};



// WEBPACK FOOTER //
// ./src/views/Layout/HeaderAndSidebarLayout/SideBar/styles.js